import { Injectable, inject } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProjectMemberPropertiesWrapper } from '../../pages/project/shared/project-detail-types';
import { UserService } from '../../pages/user/services/user.service';
import { ProjectModel } from '../models/project/project.model';

@Injectable({
  providedIn: 'root',
})
export class ProjectTransformationService {
  // DI
  private readonly userService = inject(UserService);

  public projectMemberWrapperToPlain(entries: ProjectMemberPropertiesWrapper[]): any[] {
    return entries.map((entry) => {
      return {
        member_id: entry.member.id,
        deduct_costs_from_budget: entry.deductCostsFromBudget,
      };
    });
  }

  public plainToProjectMemberWrapper(entries: any[]): Observable<ProjectMemberPropertiesWrapper[]> {
    return forkJoin(
      entries.map((entry) =>
        this.userService.getUserEnsured(entry.member_id).pipe(
          map((member) => ({
            member,
            deductCostsFromBudget: entry.deduct_costs_from_budget,
          })),
        ),
      ),
    );
  }

  public groupProjectsByClients(
    projects: ProjectModel[],
  ): Record<string | number, { label: string; category: string }> {
    return projects.reduce<Record<number, { label: string; category: string }>>((acc, project) => {
      acc[project.id] = { label: project.name, category: project.client.name } as const;
      return acc;
    }, {});
  }
}
